var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStats = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Stats",
  fill: "#3A414C"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5,10 L7,10 C7.55228475,10 8,10.4477153 8,11 L8,18 C8,18.5522847 7.55228475,19 7,19 L5,19 C4.44771525,19 4,18.5522847 4,18 L4,11 C4,10.4477153 4.44771525,10 5,10 Z M11,6 L13,6 C13.5522847,6 14,6.44771525 14,7 L14,18 C14,18.5522847 13.5522847,19 13,19 L11,19 C10.4477153,19 10,18.5522847 10,18 L10,7 C10,6.44771525 10.4477153,6 11,6 Z M17,12 L19,12 C19.5522847,12 20,12.4477153 20,13 L20,18 C20,18.5522847 19.5522847,19 19,19 L17,19 C16.4477153,19 16,18.5522847 16,18 L16,13 C16,12.4477153 16.4477153,12 17,12 Z",
  id: "Combined-Shape"
})))));
export { SvgStats as ReactComponent };
export default __webpack_public_path__ + "static/media/stats.1517a286.svg";